import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { FormsService } from '../../../core/services/forms.service';
import { ValidatorFactories } from '../../../core/validators';
import { ApiOrder } from '../../../cart/models/cart-models';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { select, Store } from '@ngrx/store';
import { Location } from '@angular/common';
import { Validators } from '@angular/forms';
import * as fromBase from '../../../base/reducers';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import chaining from '../../../core/helpers/chaining';
var referenceValidator = ValidatorFactories.reference(8);
var dateValidator = ValidatorFactories.date('mm-DD-yyyy');
var CheckoutSecondStepPageComponent = /** @class */ (function () {
    function CheckoutSecondStepPageComponent(forms, store, _location) {
        this.forms = forms;
        this.store = store;
        this._location = _location;
        this.setDetails$ = new Subject();
        this.detailsChanged = new EventEmitter();
        this.createOrder = new EventEmitter();
        this.orderForm = this.forms.group({
            dlvDate: [
                this.deliveryDate, [Validators.required, dateValidator], 'checkout.fields.deliverydate'
            ],
            customerReference: [
                this.reference, [referenceValidator], 'checkout.fields.reference'
            ],
            comments: [
                this.remarks, [], 'checkout.fields.comments'
            ]
        });
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "orderSetter", {
        set: function (value) {
            if (!value)
                return;
            this.order = value;
            this.orderForm.patchValue({
                dlvDate: value.dlvDate && moment(value.dlvDate).format('DD-MM-YYYY'),
                customerReference: value.customerReference,
                comments: value.comments
            });
            var address = this.addresses && Array.isArray(this.addresses)
                ? this.addresses.find(function (a) { return a.code === value.dlvAddress; })
                : null;
            this.setAddress('delivery', address);
        },
        enumerable: true,
        configurable: true
    });
    CheckoutSecondStepPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var withDelivery = (function (details) { return (tslib_1.__assign({}, details, { dlvAddress: _this.deliveryAddress && _this.deliveryAddress.code })); }).bind(this);
        var withOrder = (function (details) { return (tslib_1.__assign({}, _this.order, details)); });
        this.orderForm.valueChanges.pipe(filter((function (val) { return !(val.dlvDate === moment(_this.order.dlvDate).format('DD-MM-YYYY')
            && val.customerReference === _this.order.customerReference
            && val.comments === _this.order.comments); }).bind(this)), map(withDelivery))
            .subscribe(this.setDetails$);
        this.setDetails$.pipe(distinctUntilChanged(null, function (val) { return JSON.stringify(val); }), map(withOrder), debounceTime(500))
            .subscribe(this.detailsChanged);
    };
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "deliveryDate", {
        get: function () {
            return (this.order && this.order.dlvDate) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "reference", {
        get: function () {
            return (this.order && this.order.customerReference) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "remarks", {
        get: function () {
            return (this.order && this.order.comments) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "currency", {
        get: function () {
            return chaining(this.order, 'currency');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "lines", {
        get: function () {
            return (this.order && this.order.lines) || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "hasLines", {
        get: function () {
            return !!this.lines.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutSecondStepPageComponent.prototype, "deliveryAddressNumber", {
        get: function () {
            return chaining(this.order, 'dlvAddress');
        },
        enumerable: true,
        configurable: true
    });
    CheckoutSecondStepPageComponent.prototype.setAddress = function (type, address) {
        if (!address)
            return;
        switch (type) {
            case 'billing':
                this.billingAddress = address;
                break;
            case 'delivery':
                this.deliveryAddress = address;
                break;
        }
        if (type === 'delivery' && this.order && this.order.dlvAddress !== address.code)
            this.setDetails$.next(tslib_1.__assign({}, this.orderForm.value, { dlvAddress: address.code }));
    };
    CheckoutSecondStepPageComponent.prototype.submit = function () {
        if (!this.orderForm.valid) {
            this.validationResult = this.orderForm.validate();
        }
        else {
            this.validationResult = null;
            this.createOrder.emit(tslib_1.__assign({}, this.order, this.orderForm.value, { dlvAddress: this.deliveryAddress && this.deliveryAddress.code }));
        }
    };
    return CheckoutSecondStepPageComponent;
}());
export { CheckoutSecondStepPageComponent };
